import { render, staticRenderFns } from "./WizardSelections.vue?vue&type=template&id=dd7a8aec&"
import script from "./WizardSelections.vue?vue&type=script&lang=js&"
export * from "./WizardSelections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WizardSelections.vue"
export default component.exports